import axios from "axios";
import { API_STAFF_URL } from "../config/config";

const apiClient = axios.create({
  baseURL: API_STAFF_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export default apiClient;
